(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AddAccountCtrl", ["authService", "accountsResource", "groupHierarchyResource", "organizationsFilterResource", "rolesResource", "messageService", "frameworkService", "$rootScope", "$q", "_", "REG_EXP", "USER_ROLES", addAccountCtrl]);
    function addAccountCtrl(authService, accountsResource, groupHierarchyResource, organizationsFilterResource, rolesResource, messageService, frameworkService, $rootScope, $q, _, REG_EXP, USER_ROLES) {
        var vm = this;
        vm.passwordPattern = REG_EXP.password;
        vm.emailPattern = REG_EXP.email;
        vm.userNamePattern = REG_EXP.username;
        vm.showRoleError = false;
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.isOrgAdmin = authService.isOrgAdmin();
        vm.isGroupAdmin = authService.isGroupAdmin();
        vm.isSuperOrSiteAdmin = authService.isSuperOrSiteAdmin();
        var organizationEnabled = frameworkService.data.tenantFeatures.organization;
        vm.organizationRequired = frameworkService.data.tenant.tenantFeaturesOrganizationIsRequired || vm.isOrgAdmin; //required if user is an org admin
        vm.organizationHierarchyType = frameworkService.data.tenant.tenantFeaturesOrganizationHierarchyType;
        vm.showOrgDropdown = organizationEnabled && (vm.isSuperOrSiteAdmin || (vm.isOrgAdmin && vm.organizationHierarchyType === 2));
        vm.organization = null;
        vm.groupEnabled = frameworkService.data.tenant.hasGroups;
        vm.groupRequired = true;
        vm.showGroupDropdown = vm.isSuperOrSiteAdmin || vm.isGroupAdmin;
        vm.account = {};
        vm.account.localizationId = angular.copy(frameworkService.data.selectedLanguage.id),
            vm.account.roles = [];
        vm.emailRequired = frameworkService.data.tenantFeatures.selfRegistration;
        rolesResource.getCurrentUserRoles(function (data) {
            vm.roles = [];
            angular.forEach(data, function (role) {
                if (role.name === USER_ROLES.forumModerator && !frameworkService.data.tenantFeatures.forums)
                    return;
                else if (role.name === USER_ROLES.organizationAdmin && !frameworkService.data.tenantFeatures.organization)
                    return;
                else if (role.name === USER_ROLES.groupAdmin && !frameworkService.data.tenant.hasGroups)
                    return;
                vm.roles.push(role);
            });
            //vm.roles = data;
            vm.rolesLoaded = true;
            vm.learnerRole = data[0];
            vm.account.roles = [vm.learnerRole.name];
        });
        //Populate groups list
        if (vm.showGroupDropdown) {
            groupHierarchyResource.query({ showAllGroups: false }, function (data) {
                if (!data || data.length === 0)
                    messageService.error("account.error.groupsNotLoaded");
                vm.groups = data;
                if (vm.groups.length === 1) {
                    vm.group = vm.groups[0];
                    vm.account.groupId = vm.group.id;
                }
            });
        }
        vm.checkBoxClicked = function (roleName) {
            if (roleName === USER_ROLES.siteAdmin) {
                var index = vm.account.roles.indexOf(USER_ROLES.siteAdmin);
                if (index >= 0) {
                    //uncheck org and group admin
                    vm.siteAdminChecked = true;
                    var roles = angular.copy(vm.account.roles);
                    vm.account.roles = [];
                    angular.forEach(roles, function (role) {
                        if (role === USER_ROLES.organizationAdmin || (role === USER_ROLES.groupAdmin))
                            return;
                        vm.account.roles.push(role);
                    });
                }
                else {
                    vm.siteAdminChecked = false;
                }
                //vm.roles = angular.copy(vm.roles);
            }
        };
        //Create Account
        vm.createAccount = function (isValid) {
            if (!vm.areRolesValid())
                isValid = false;
            if (isValid) {
                vm.saving = true;
                accountsResource.save(vm.account, function () {
                    vm.showConfirmation = true;
                    $rootScope.$broadcast("RefreshUserNotifications");
                    $rootScope.$broadcast("reloadAccountList");
                    $rootScope.$broadcast("checkSubscription");
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        //Clears form to be able to add another
        vm.createAnother = function () {
            vm.createAnotherLocalizationId = angular.copy(vm.account.localizationId);
            vm.showConfirmation = false;
            vm.saving = false;
            vm.account = { localizationId: vm.createAnotherLocalizationId };
            vm.account.roles = [vm.learnerRole.name];
            vm.group = null;
            vm.organization = null;
            if (vm.groups.length === 1) {
                vm.group = vm.groups[0];
                vm.account.groupId = vm.group.id;
            }
            vm.showErrors = false;
        };
        //checks if user name is formatted like email and places in email input
        vm.userNameEmail = function () {
            if (!(vm.account.userName === "" || vm.account.userName === undefined)) {
                if (vm.account.userName.match(vm.emailPattern))
                    vm.account.email = vm.account.userName;
            }
        };
        //Validation for at least one role Selected
        vm.areRolesValid = function () {
            var valid = vm.account.roles && vm.account.roles.length >= 1;
            vm.showRoleError = !valid;
            return valid;
        };
        //Check username availability for tenant
        vm.checkUsernameIsAvailable = function (username) {
            return $q(function (resolve, reject) {
                accountsResource.isUsernameAvailable({ actionValue: username }, function (result) {
                    if (result.value)
                        resolve(true);
                    else
                        reject();
                });
            });
        };
        vm.groupChanged = function () {
            if (vm.group)
                vm.account.groupId = vm.group.id;
            else
                vm.account.groupId = null;
        };
        vm.organizationChanged = function () {
            if (vm.organization)
                vm.account.organizationId = vm.organization.id;
            else
                vm.account.organizationId = null;
        };
        vm.refreshOrganizations = function (val) {
            organizationsFilterResource.getCachedEnabled({ name: val }, function (result) {
                vm.organizations = result;
            });
        };
    }
}());
